import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';

const GarminAttribution: React.FC = () => {
    const { isDark } = useTheme();

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end',
                margin: 16,
                width: '100%',
                boxSizing: 'border-box',
            }}
        >
            <img
                src="/logos/garmin/garmin-branding/Garmin_Connect_app_1024x1024-02.png"
                alt="Garmin Connect Logo"
                style={{ 
                    width: 30, 
                    height: 30, 
                    marginRight: 6, 
                    opacity: 0.85, 
                    padding: 0,
                    borderRadius: 6,
                }}
            />
            <span
                className="cgm-text-primary"
                style={{
                    fontSize: 10,
                    fontWeight: 600,
                    letterSpacing: '0.05em',
                    opacity: 0.85,
                    textShadow: isDark ? '0 1px 2px #000' : '0 1px 2px #fff',
                    padding: 0,
                }}
            >
                Data powered by Garmin
            </span>
        </div>
    );
};

export default GarminAttribution;
